import React, { useState, useEffect } from 'react';
import SectionHeading from '../atoms/SectionHeading';
import Button from '../atoms/Button';

const BookingSection = ({ selectedService }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: 'The Minimalist', // Default
        datetime: '',
        notes: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    // Update form when prop changes
    useEffect(() => {
        if (selectedService) {
            setFormData(prev => ({ ...prev, service: selectedService }));
        }
    }, [selectedService]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Simulate API call
        setTimeout(() => {
            setIsSubmitting(false);
            setSubmitSuccess(true);
            // Reset form after 3 seconds or keep it success state
            setTimeout(() => setSubmitSuccess(false), 5000);
            setFormData({
                name: '',
                email: '',
                phone: '',
                service: 'The Minimalist',
                datetime: '',
                notes: ''
            });
            alert(`Booking Request Sent!\nWe've received your request for: ${formData.service}\nWe will contact you at ${formData.phone} shortly.`);
        }, 1500);
    };

    return (
        <section id="booking" className="py-24 bg-purple-50">
            <div className="container mx-auto px-6 max-w-4xl">
                <SectionHeading
                    title="Reserve Your Spot"
                    subtitle="Book an Appointment"
                    className="mb-12"
                />

                <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid md:grid-cols-2 gap-6">
                            {/* Name */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-colors"
                                    placeholder="Your Name"
                                />
                            </div>

                            {/* Phone */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Phone</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-colors"
                                    placeholder="(555) 000-0000"
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-colors"
                                placeholder="hello@example.com"
                            />
                        </div>

                        <div className="grid md:grid-cols-2 gap-6">
                            {/* Service Selection */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Service Tier</label>
                                <select
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-colors appearance-none"
                                >
                                    <option value="The Minimalist">The Minimalist ($85+)</option>
                                    <option value="The Elevated">The Elevated ($145+)</option>
                                    <option value="The Masterpiece">The Masterpiece ($250+)</option>
                                </select>
                            </div>

                            {/* Date/Time Preference */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Preferred Time</label>
                                <input
                                    type="datetime-local"
                                    name="datetime"
                                    value={formData.datetime}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-colors"
                                />
                            </div>
                        </div>

                        {/* Notes */}
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Special Requests</label>
                            <textarea
                                name="notes"
                                value={formData.notes}
                                onChange={handleChange}
                                rows="3"
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-colors"
                                placeholder="Any specific designs, colors, or removal needed?"
                            ></textarea>
                        </div>

                        <Button
                            type="submit"
                            variant="primary"
                            className="w-full py-4 text-base"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Sending Request...' : 'Confirm Request'}
                        </Button>

                        {submitSuccess && (
                            <p className="text-center text-green-600 font-bold mt-4 animate-pulse">
                                Request received! We'll be in touch shortly.
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </section>
    );
};

export default BookingSection;
